import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Profile } from '@cyborg-monorepo/hunter/common';
import { AuthService } from '../../auth/auth.service';
import { SupportService } from '../../modules/shared/services/support.service';
import { UserService } from '../../modules/shared/services/user.service';
import { MessageConfirmationDialogComponent } from './message-confirmation-dialog/message-confirmation-dialog.component';
import { DialogService } from '@hyperkit';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactUsComponent implements OnInit {
  private userService = inject(UserService);
  private authService = inject(AuthService);
  private supportService = inject(SupportService);
  private dialogService = inject(DialogService);

  public contactForm!: FormGroup;
  public error = '';

  public ngOnInit(): void {
    this.contactForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone: new FormControl(''),
      message: new FormControl('', [Validators.required]),
      website: new FormControl(''),
      newsletter: new FormControl(false),
    });

    if (this.authService.isAuthenticated()) {
      this.userService.getProfile().pipe(
        tap((profile: Profile) => {
          this.contactForm.patchValue({
            name: `${profile.firstName} ${profile.lastName}`,
            email: profile.email,
          });
        })
      ).subscribe();
    }
  }

  public onSendContact(): void {
    this.supportService
      .sendContactEmail(this.contactForm.value)
      .subscribe({
        next: () => {
          this.contactForm.reset(); // Clears the form after submission
          this.dialogService.open(MessageConfirmationDialogComponent, {
            panelClass: 'hyperkit-component',
          });
        },
        error: (error) => {
          this.error = error.message || 'An error occurred while sending the message.';
        },
      });
  }
}
